
import dust from "dustjs-linkedin";


(function(){dust.register("show-file",body_0);function body_0(chk,ctx){return chk.write("<div class=\"file-content\">").helper("text2html",ctx,{},{"text":ctx.get(["fileContent"], false)}).write("</div>");}return body_0;})();

export default 0;
